
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/integrations/bitrix",
      function () {
        return require("private-next-pages/[locale]/integrations/bitrix.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/integrations/bitrix"])
      });
    }
  